import initialStateAuth from './auth/initialState.js';
import initialStatePortal from './portal/initialState.js';
import initialStateGuis from './guis/initialState.js';
import initialStateDashboard from './dashboard/initialState.js';

export default {
  ...initialStateAuth,
  ...initialStatePortal,
  ...initialStateGuis,
  ...initialStateDashboard
};
